import Toast from "react-native-toast-message";
import i18next from "i18next";

const DEFAULT_TOAST_OPTIONS = {
  position: "bottom" as const,
  visibilityTime: 2000,
  props: {
    height: 300,
    fontSize: 14,
  },
  text1Style: {
    fontSize: 16,
  },
  text2Style: {
    fontSize: 14,
    color: "#100f14ff",
  },
};

type ToastType = "success" | "error" | "info";

export const showToast = (
  type: ToastType,
  text1Key: string,
  fallback1: string,
  text2?: string
) => {
  Toast.show({
    ...DEFAULT_TOAST_OPTIONS,
    type,
    text1: i18next.t(text1Key, fallback1),
    text2,
  });
};

// convenience wrappers
export const toast = {
  success: (text1Key: string, fallback1: string, text2?: string) =>
    showToast("success", text1Key, fallback1, text2),
  error: (text1Key: string, fallback1: string, text2?: string) =>
    showToast("error", text1Key, fallback1, text2),
  info: (text1Key: string, fallback1: string, text2?: string) =>
    showToast("info", text1Key, fallback1, text2),
};
